$(document).ready(function () {
  $(".contact-select").change(function () {
    var val = $(this).val();
    if (val === "sales") {
      $("#sales_form").show().slideDown();
      $("#shipping_form").hide();
      $("#support_form").hide();
      $("#rma_form").hide();
    } else if (val === "shipping") {
      $("#shipping_form").show().slideDown();
      $("#sales_form").hide();
      $("#support_form").hide();
      $("#rma_form").hide();
    } else if (val === "support") {
      $("#support_form").show().slideDown();
      $("#shipping_form").hide();
      $("#sales_form").hide();
      $("#rma_form").hide();
    } else if (val === "rma") {
      $("#rma_form").show().slideDown();
      $("#support_form").hide();
      $("#shipping_form").hide();
      $("#sales_form").hide();
    }
  });
});
